var _g, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4596_14700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9943 24.9438L29.7026 21.6483L33 27.3594L36.3215 25.4417L31.1065 16.4087L22.0768 21.6224L23.9943 24.9438ZM16.4099 24.8937L19.7315 22.976L21.6491 26.2974L18.3275 28.2151L16.4099 24.8937ZM23.0031 28.6433L26.2988 34.3514L32.0098 31.0543L33.9293 34.3747L33.9276 34.3758L24.8949 39.591L19.6814 30.5611L19.6787 30.5564L23.0031 28.6433ZM34.3526 29.703L37.6742 27.7853L39.5918 31.1067L36.2702 33.0244L34.3526 29.703Z",
    fill: "url(#paint0_linear_4596_14700)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9943 24.9438L29.7026 21.6483L33 27.3594L36.3215 25.4417L31.1065 16.4087L22.0768 21.6224L23.9943 24.9438ZM16.4099 24.8937L19.7315 22.976L21.6491 26.2974L18.3275 28.2151L16.4099 24.8937ZM23.0031 28.6433L26.2988 34.3514L32.0098 31.0543L33.9293 34.3747L33.9276 34.3758L24.8949 39.591L19.6814 30.5611L19.6787 30.5564L23.0031 28.6433ZM34.3526 29.703L37.6742 27.7853L39.5918 31.1067L36.2702 33.0244L34.3526 29.703Z",
    fill: "url(#paint1_linear_4596_14700)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5433 28.9473L31.5448 28.9477L28.9502 24.4538L25.6291 26.3712L25.629 26.3712L25.2474 26.5916L24.4604 27.0461L24.4542 27.0496L24.4577 27.056L27.0499 31.546L31.5438 28.9514L31.5461 28.9499L31.5433 28.9473Z",
    fill: "#F3BA2F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4596_14700",
    x: 0.410156,
    y: 0.408691,
    width: 55.1816,
    height: 55.1824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_4596_14700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_14700",
    x1: 31.1067,
    y1: 16.4088,
    x2: 24.8951,
    y2: 39.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD05C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4596_14700",
    x1: 31.1067,
    y1: 16.4088,
    x2: 24.8951,
    y2: 39.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD05C"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBnb);
export default __webpack_public_path__ + "static/media/ic_bnb.8142a84bfdb4ee2a28657e5e3bdd8c42.svg";
export { ForwardRef as ReactComponent };